import { Component, OnInit, ViewChild } from '@angular/core';
import { EpbtFaProductBinlocationService } from '../../services/epbt-fa-product-binlocation.service';
import { EpEventService, EpButtonStyle } from '@epicor/kinetic';
import { CustomEvents } from 'ep-bt-controls';
import { EpbtFaBinLocationSelectedProductGridComponent } from '../epbt-fa-bin-location-selected-product-grid/epbt-fa-bin-location-selected-product-grid.component';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-bin-location-summary',
  templateUrl: './epbt-fa-bin-location-summary.component.html',
  styleUrls: ['./epbt-fa-bin-location-summary.component.scss']
})
export class EpbtFaBinLocationSummaryComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;

  public radioButtonData = ['Add', 'Remove', 'Replace'];

  @ViewChild(EpbtFaBinLocationSelectedProductGridComponent, {static: false}) epbtFaBinLocationSelectedProductGridComponent: EpbtFaBinLocationSelectedProductGridComponent;

  constructor(public binLocationService: EpbtFaProductBinlocationService,
    public epEvent: EpEventService, private location: Location,
    private router: Router,
    private productService: EpbtFaProductService) { }

  ngOnInit() {
    this.updateGridData();
  }

  onBranchClick() {
    this.epEvent.broadcast(CustomEvents.BinLocationSummaryClick, 0);
  }

  applyClicked() {
    this.binLocationService.saveBinLocations((result: any) => {
      this.binLocationService.result = result;

      this.binLocationService.result.forEach(res => {
        if (res.errorMessage == null) {
          this.binLocationService.successCount = this.binLocationService.successCount + 1;
        }
      });

      this.binLocationService.errorMessage = this.binLocationService.successCount + ' of ' + this.binLocationService.result.length + ' requests were successfully submitted.';
    });
  }

  onSelectionChange(event: any) {
    this.updateGridData();
  }

  updateGridData() {
    if (this.binLocationService.selectedRadioButton == 'Add' || this.binLocationService.selectedRadioButton == 'Replace') {
      this.epbtFaBinLocationSelectedProductGridComponent.updateGridData(true);
    } else {
      this.epbtFaBinLocationSelectedProductGridComponent.updateGridData(true);
    }
  }

  doneClicked() {
    if (this.binLocationService.fromDashbard) {
      this.router.navigate(['/home']);
    } else {
      if (this.productService.selectedProductItem) {
        this.router.navigate(['/home/product/details/', this.productService.selectedProductItem.productId]);
      } else {
        this.router.navigate(['/home']);
      }
    }
    this.binLocationService.clearData();
  }
}
